/**
 * Copyright Aquera Inc 2023
 *
 * This source code is licensed under the BSD-3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { css } from 'lit';

/**
 * List CSS
 */
export const styles = css`
  :host {
    display: flex;
    flex-direction: column;
    gap: var(--nile-spacing-9px, var(--ng-spacing-md));
    padding: var(--nile-spacing-xl, var(--ng-spacing-xl));
    -webkit-font-smoothing: var(--nile-webkit-font-smoothing, var(--ng-webkit-font-smoothing));
    -moz-osx-font-smoothing: var(--nile-moz-osx-font-smoothing, var(--ng-moz-osx-font-smoothing));
    text-rendering: var(--nile-text-rendering, var(--ng-text-rendering));
  }
`;

export default [styles];
